"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketService = void 0;
const socket_io_client_1 = require("socket.io-client");
const managerOptions = {
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    transports: ["websocket"],
};
class SocketService {
    constructor(socketData, token) {
        this.handlers = {};
        this.socketData = socketData;
        this.sockets = socketData.map(({ url }) => {
            const socketOptions = Object.assign({ auth: {
                    token,
                } }, managerOptions);
            const manager = new socket_io_client_1.Manager(url, managerOptions);
            return manager.socket("/", socketOptions);
        });
    }
    startListening() {
        for (const { eventName, callback } of this.socketData) {
            this.handlers[eventName] = callback;
            for (const socket of this.sockets) {
                socket.on(eventName, callback);
            }
        }
    }
    stopListening() {
        for (const { eventName } of this.socketData) {
            const callback = this.handlers[eventName];
            if (callback) {
                for (const socket of this.sockets) {
                    socket.off(eventName, callback);
                }
                delete this.handlers[eventName];
            }
        }
    }
    emitEvent(eventName, data) {
        for (const socket of this.sockets) {
            socket.emit(eventName, data);
        }
    }
    close() {
        for (const socket of this.sockets) {
            socket.disconnect();
        }
    }
}
exports.SocketService = SocketService;
